import { StationList } from 'app/features/search/model/stations-list';

export function stationList(): StationList[] {
  return stations;
}

export const stations: StationList[] = [
  {
    "stationCode": "ABE",
    "stationName": "Allentown, PA, USA"
  },
  {
    "stationCode": "ABI",
    "stationName": "Abilene, TX, USA"
  },
  {
    "stationCode": "ABQ",
    "stationName": "Albuquerque, NM, USA"
  },
  {
    "stationCode": "ABY",
    "stationName": "Albany, GA, USA"
  },
  {
    "stationCode": "ACA",
    "stationName": "Acapulco, Mexico"
  },
  {
    "stationCode": "ACT",
    "stationName": "Waco, TX, USA"
  },
  {
    "stationCode": "ACY",
    "stationName": "Atlantic City, NJ, USA"
  },
  {
    "stationCode": "ADM",
    "stationName": "Ardmore, OK, USA"
  },
  {
    "stationCode": "ADW",
    "stationName": "Camp Springs, MD, USA"
  },
  {
    "stationCode": "ADZ",
    "stationName": "San Andres Island, Colombia"
  },
  {
    "stationCode": "AEX",
    "stationName": "Alexandria, LA, USA"
  },
  {
    "stationCode": "AFW",
    "stationName": "Fort Worth, TX, USA"
  },
  {
    "stationCode": "AGS",
    "stationName": "Augusta, GA, USA"
  },
  {
    "stationCode": "AGT",
    "stationName": "Ciudad del Este, Paraguay"
  },
  {
    "stationCode": "AJU",
    "stationName": "Aracaju, Brazil"
  },
  {
    "stationCode": "AKH",
    "stationName": "Al Kharj, Saudi Arabia"
  },
  {
    "stationCode": "AKL",
    "stationName": "Auckland, New Zealand"
  },
  {
    "stationCode": "ALB",
    "stationName": "Albany, NY, USA"
  },
  {
    "stationCode": "AMA",
    "stationName": "Amarillo, TX, USA"
  },
  {
    "stationCode": "AMS",
    "stationName": "Amsterdam, Netherlands"
  },
  {
    "stationCode": "ANB",
    "stationName": "Anniston, AL, USA"
  },
  {
    "stationCode": "ANC",
    "stationName": "Anchorage, AK, USA"
  },
  {
    "stationCode": "ANF",
    "stationName": "Antofagasta, Chile"
  },
  {
    "stationCode": "ANU",
    "stationName": "St. John's, Antigua and Barbuda"
  },
  {
    "stationCode": "APN",
    "stationName": "Alpena, MI, USA"
  },
  {
    "stationCode": "ARA",
    "stationName": "New Iberia, LA, USA"
  },
  {
    "stationCode": "ARI",
    "stationName": "Arica, Chile"
  },
  {
    "stationCode": "ARN",
    "stationName": "Stockholm, Sweden"
  },
  {
    "stationCode": "ASU",
    "stationName": "Asuncion, Paraguay"
  },
  {
    "stationCode": "ATH",
    "stationName": "Athens, Greece"
  },
  {
    "stationCode": "ATL",
    "stationName": "Atlanta, GA, USA"
  },
  {
    "stationCode": "ATO",
    "stationName": "Athens, OH, USA"
  },
  {
    "stationCode": "ATW",
    "stationName": "Appleton, WI, USA"
  },
  {
    "stationCode": "AUA",
    "stationName": "Oranjestad, Aruba"
  },
  {
    "stationCode": "AUS",
    "stationName": "Austin, TX, USA"
  },
  {
    "stationCode": "AVB",
    "stationName": "Aviano, Italy"
  },
  {
    "stationCode": "AVL",
    "stationName": "Asheville, NC, USA"
  },
  {
    "stationCode": "AVP",
    "stationName": "Scranton, PA, USA"
  },
  {
    "stationCode": "AZO",
    "stationName": "Kalamazoo, MI, USA"
  },
  {
    "stationCode": "BAD",
    "stationName": "Shreveport, LA, USA"
  },
  {
    "stationCode": "BAF",
    "stationName": "Westfield/Springfield, MA, USA"
  },
  {
    "stationCode": "BAH",
    "stationName": "Manama, Bahrain"
  },
  {
    "stationCode": "BAQ",
    "stationName": "Barranquilla, Colombia"
  },
  {
    "stationCode": "BCE",
    "stationName": "Bryce Canyon, UT, USA"
  },
  {
    "stationCode": "BCN",
    "stationName": "Barcelona, Spain"
  },
  {
    "stationCode": "BDA",
    "stationName": "Hamilton, Bermuda"
  },
  {
    "stationCode": "BDL",
    "stationName": "Hartford, CT, USA"
  },
  {
    "stationCode": "BED",
    "stationName": "Bedford, MA, USA"
  },
  {
    "stationCode": "BFI",
    "stationName": "Seattle, WA, USA"
  },
  {
    "stationCode": "BFL",
    "stationName": "Bakersfield, CA, USA"
  },
  {
    "stationCode": "BFM",
    "stationName": "Mobile, AL, USA"
  },
  {
    "stationCode": "BFS",
    "stationName": "Belfast, Northern Ireland, UK"
  },
  {
    "stationCode": "BGI",
    "stationName": "Bridgetown, Barbados"
  },
  {
    "stationCode": "BGM",
    "stationName": "Binghamton, NY, USA"
  },
  {
    "stationCode": "BGR",
    "stationName": "Bangor, ME, USA"
  },
  {
    "stationCode": "BHM",
    "stationName": "Birmingham, AL, USA"
  },
  {
    "stationCode": "BHX",
    "stationName": "Birmingham, England, UK"
  },
  {
    "stationCode": "BIF",
    "stationName": "El Paso, TX, USA"
  },
  {
    "stationCode": "BIL",
    "stationName": "Billings, MT, USA"
  },
  {
    "stationCode": "BIS",
    "stationName": "Bismarck, ND, USA"
  },
  {
    "stationCode": "BIX",
    "stationName": "Biloxi, MS, USA"
  },
  {
    "stationCode": "BJC",
    "stationName": "Broomfield, CO, USA"
  },
  {
    "stationCode": "BJI",
    "stationName": "Bemidji, MN, USA"
  },
  {
    "stationCode": "BJX",
    "stationName": "Leon, Mexico"
  },
  {
    "stationCode": "BKF",
    "stationName": "Buckley ANGB, CO, USA"
  },
  {
    "stationCode": "BKL",
    "stationName": "Cleveland, OH, USA"
  },
  {
    "stationCode": "BLQ",
    "stationName": "Bologna, Italy"
  },
  {
    "stationCode": "BLV",
    "stationName": "Belleville, IL, USA"
  },
  {
    "stationCode": "BMG",
    "stationName": "Bloomington, IN, USA"
  },
  {
    "stationCode": "BNA",
    "stationName": "Nashville, TN, USA"
  },
  {
    "stationCode": "BNE",
    "stationName": "Brisbane, QLD, Australia"
  },
  {
    "stationCode": "BOG",
    "stationName": "Bogota, Colombia"
  },
  {
    "stationCode": "BOI",
    "stationName": "Boise, ID, USA"
  },
  {
    "stationCode": "BOJ",
    "stationName": "Burgas, Bulgaria"
  },
  {
    "stationCode": "BON",
    "stationName": "Kralendijk, Bonaire, Netherlands"
  },
  {
    "stationCode": "BOS",
    "stationName": "Boston, MA, USA"
  },
  {
    "stationCode": "BPT",
    "stationName": "Beaumont/Port Arthur, TX, USA"
  },
  {
    "stationCode": "BQN",
    "stationName": "Aguadilla, Puerto Rico"
  },
  {
    "stationCode": "BRU",
    "stationName": "Brussels, Belgium"
  },
  {
    "stationCode": "BSB",
    "stationName": "Brasília, Brazil"
  },
  {
    "stationCode": "BSM",
    "stationName": "Bishe Kola, Iran"
  },
  {
    "stationCode": "BTL",
    "stationName": "Battle Creek, MI, USA"
  },
  {
    "stationCode": "BTM",
    "stationName": "Butte, MT, USA"
  },
  {
    "stationCode": "BTR",
    "stationName": "Baton Rouge, LA, USA"
  },
  {
    "stationCode": "BTV",
    "stationName": "Burlington, VT, USA"
  },
  {
    "stationCode": "BUD",
    "stationName": "Budapest, Hungary"
  },
  {
    "stationCode": "BUF",
    "stationName": "Buffalo, NY, USA"
  },
  {
    "stationCode": "BUR",
    "stationName": "Burbank, CA, USA"
  },
  {
    "stationCode": "BVB",
    "stationName": "Boa Vista, Brazil"
  },
  {
    "stationCode": "BWG",
    "stationName": "Bowling Green, KY, USA"
  },
  {
    "stationCode": "BWI",
    "stationName": "Baltimore, MD, USA"
  },
  {
    "stationCode": "BYH",
    "stationName": "Blytheville, AR, USA"
  },
  {
    "stationCode": "BZE",
    "stationName": "Belize City, Belize"
  },
  {
    "stationCode": "BZN",
    "stationName": "Bozeman, MT, USA"
  },
  {
    "stationCode": "CAE",
    "stationName": "Columbia, SC, USA"
  },
  {
    "stationCode": "CAK",
    "stationName": "Akron/Canton, OH, USA"
  },
  {
    "stationCode": "CAP",
    "stationName": "Cap-Haïtien, Haiti"
  },
  {
    "stationCode": "CBB",
    "stationName": "Cochabamba, Bolivia"
  },
  {
    "stationCode": "CBR",
    "stationName": "Canberra, Australia"
  },
  {
    "stationCode": "CCP",
    "stationName": "Concepción, Chile"
  },
  {
    "stationCode": "CCS",
    "stationName": "Caracas, Venezuela"
  },
  {
    "stationCode": "CDB",
    "stationName": "Cold Bay, AK, USA"
  },
  {
    "stationCode": "CDG",
    "stationName": "Paris, France"
  },
  {
    "stationCode": "CFG",
    "stationName": "Cienfuegos, Cuba"
  },
  {
    "stationCode": "CGN",
    "stationName": "Cologne, Germany"
  },
  {
    "stationCode": "CHA",
    "stationName": "Chattanooga, TN, USA"
  },
  {
    "stationCode": "CHC",
    "stationName": "Christchurch, New Zealand"
  },
  {
    "stationCode": "CHO",
    "stationName": "Charlottesville, VA, USA"
  },
  {
    "stationCode": "CHS",
    "stationName": "Charleston, SC, USA"
  },
  {
    "stationCode": "CIA",
    "stationName": "Rome, Italy"
  },
  {
    "stationCode": "CID",
    "stationName": "Cedar Rapids, IA, USA"
  },
  {
    "stationCode": "CIX",
    "stationName": "Chiclayo, Peru"
  },
  {
    "stationCode": "CJU",
    "stationName": "Jeju, South Korea"
  },
  {
    "stationCode": "CKB",
    "stationName": "Clarksburg, WV, USA"
  },
  {
    "stationCode": "CLE",
    "stationName": "Cleveland, OH, USA"
  },
  {
    "stationCode": "CLL",
    "stationName": "College Station, TX, USA"
  },
  {
    "stationCode": "CLO",
    "stationName": "Cali, Colombia"
  },
  {
    "stationCode": "CLT",
    "stationName": "Charlotte, NC, USA"
  },
  {
    "stationCode": "CMH",
    "stationName": "Columbus, OH, USA"
  },
  {
    "stationCode": "CMI",
    "stationName": "Champaign/Urbana, IL, USA"
  },
  {
    "stationCode": "CMW",
    "stationName": "Camagüey, Cuba"
  },
  {
    "stationCode": "CND",
    "stationName": "Constanța, Romania"
  },
  {
    "stationCode": "CNF",
    "stationName": "Belo Horizonte, Brazil"
  },
  {
    "stationCode": "CNW",
    "stationName": "Waco, TX, USA"
  },
  {
    "stationCode": "COR",
    "stationName": "Córdoba, Argentina"
  },
  {
    "stationCode": "COS",
    "stationName": "Colorado Springs, CO, USA"
  },
  {
    "stationCode": "COU",
    "stationName": "Columbia, MO, USA"
  },
  {
    "stationCode": "CPH",
    "stationName": "Copenhagen, Denmark"
  },
  {
    "stationCode": "CPR",
    "stationName": "Casper, WY, USA"
  },
  {
    "stationCode": "CPS",
    "stationName": "St. Louis, MO, USA"
  },
  {
    "stationCode": "CRP",
    "stationName": "Corpus Christi, TX, USA"
  },
  {
    "stationCode": "CRW",
    "stationName": "Charleston, WV, USA"
  },
  {
    "stationCode": "CSG",
    "stationName": "Columbus, GA, USA"
  },
  {
    "stationCode": "CTG",
    "stationName": "Cartagena, Colombia"
  },
  {
    "stationCode": "CTS",
    "stationName": "Sapporo, Japan"
  },
  {
    "stationCode": "CUN",
    "stationName": "Cancún, Mexico"
  },
  {
    "stationCode": "CUR",
    "stationName": "Willemstad, Curaçao"
  },
  {
    "stationCode": "CUU",
    "stationName": "Chihuahua, Mexico"
  },
  {
    "stationCode": "CUZ",
    "stationName": "Cusco, Peru"
  },
  {
    "stationCode": "CVG",
    "stationName": "Cincinnati, OH, USA"
  },
  {
    "stationCode": "CWB",
    "stationName": "Curitiba, Brazil"
  },
  {
    "stationCode": "CWF",
    "stationName": "Lake Charles, LA, USA"
  },
  {
    "stationCode": "CYS",
    "stationName": "Cheyenne, WY, United States"
  },
  {
    "stationCode": "CZM",
    "stationName": "Cozumel, Quintana Roo, Mexico"
  },
  {
    "stationCode": "DAB",
    "stationName": "Daytona Beach, FL, United States"
  },
  {
    "stationCode": "DAL",
    "stationName": "Dallas (Love Field), TX, United States"
  },
  {
    "stationCode": "DAY",
    "stationName": "Dayton, OH, United States"
  },
  {
    "stationCode": "DBQ",
    "stationName": "Dubuque, IA, United States"
  },
  {
    "stationCode": "DBV",
    "stationName": "Dubrovnik, Croatia"
  },
  {
    "stationCode": "DCA",
    "stationName": "Washington, D.C. (Reagan National), United States"
  },
  {
    "stationCode": "DEL",
    "stationName": "Delhi, India"
  },
  {
    "stationCode": "DEN",
    "stationName": "Denver, CO, United States"
  },
  {
    "stationCode": "DFW",
    "stationName": "Dallas/Fort Worth, TX, United States"
  },
  {
    "stationCode": "DGO",
    "stationName": "Durango, Durango, Mexico"
  },
  {
    "stationCode": "DHN",
    "stationName": "Dothan, AL, United States"
  },
  {
    "stationCode": "DLC",
    "stationName": "Dalian, Liaoning, China"
  },
  {
    "stationCode": "DLH",
    "stationName": "Duluth, MN, United States"
  },
  {
    "stationCode": "DM",
    "stationName": "Doomadgee, Queensland, Australia"
  },
  {
    "stationCode": "DME",
    "stationName": "Moscow (Domodedovo), Russia"
  },
  {
    "stationCode": "DOH",
    "stationName": "Doha, Qatar"
  },
  {
    "stationCode": "DPA",
    "stationName": "West Chicago (Dupage Airport), IL, United States"
  },
  {
    "stationCode": "DRO",
    "stationName": "Durango, CO, United States"
  },
  {
    "stationCode": "DSM",
    "stationName": "Des Moines, IA, United States"
  },
  {
    "stationCode": "DTW",
    "stationName": "Detroit, MI, United States"
  },
  {
    "stationCode": "DUB",
    "stationName": "Dublin, Ireland"
  },
  {
    "stationCode": "DUS",
    "stationName": "Düsseldorf, Germany"
  },
  {
    "stationCode": "ECP",
    "stationName": "Panama City, FL, United States"
  },
  {
    "stationCode": "EDI",
    "stationName": "Edinburgh, Scotland, United Kingdom"
  },
  {
    "stationCode": "EFD",
    "stationName": "Houston (Ellington Field), TX, United States"
  },
  {
    "stationCode": "EGE",
    "stationName": "Eagle, CO, United States"
  },
  {
    "stationCode": "ELP",
    "stationName": "El Paso, TX, United States"
  },
  {
    "stationCode": "ERI",
    "stationName": "Erie, PA, United States"
  },
  {
    "stationCode": "EUG",
    "stationName": "Eugene, OR, United States"
  },
  {
    "stationCode": "EVV",
    "stationName": "Evansville, IN, United States"
  },
  {
    "stationCode": "EWR",
    "stationName": "Newark, NJ, United States"
  },
  {
    "stationCode": "EYW",
    "stationName": "Key West, FL, United States"
  },
  {
    "stationCode": "EZE",
    "stationName": "Buenos Aires (Ezeiza), Argentina"
  },
  {
    "stationCode": "FAI",
    "stationName": "Fairbanks, AK, United States"
  },
  {
    "stationCode": "FAR",
    "stationName": "Fargo, ND, United States"
  },
  {
    "stationCode": "FAT",
    "stationName": "Fresno, CA, United States"
  },
  {
    "stationCode": "FAY",
    "stationName": "Fayetteville, NC, United States"
  },
  {
    "stationCode": "FCA",
    "stationName": "Kalispell, MT, United States"
  },
  {
    "stationCode": "FCO",
    "stationName": "Rome (Fiumicino), Italy"
  },
  {
    "stationCode": "FDF",
    "stationName": "Fort-de-France, Martinique"
  },
  {
    "stationCode": "FFD",
    "stationName": "Fairford, England, United Kingdom"
  },
  {
    "stationCode": "FFO",
    "stationName": "Dayton (Wright-Patterson AFB), OH, United States"
  },
  {
    "stationCode": "FLG",
    "stationName": "Flagstaff, AZ, United States"
  },
  {
    "stationCode": "FLL",
    "stationName": "Fort Lauderdale, FL, United States"
  },
  {
    "stationCode": "FOE",
    "stationName": "Topeka, KS, United States"
  },
  {
    "stationCode": "FPO",
    "stationName": "Freeport, Bahamas"
  },
  {
    "stationCode": "FRA",
    "stationName": "Frankfurt, Germany"
  },
  {
    "stationCode": "FSD",
    "stationName": "Sioux Falls, SD, United States"
  },
  {
    "stationCode": "FSM",
    "stationName": "Fort Smith, AR, United States"
  },
  {
    "stationCode": "FTW",
    "stationName": "Fort Worth, TX, United States"
  },
  {
    "stationCode": "FWA",
    "stationName": "Fort Wayne, IN, United States"
  },
  {
    "stationCode": "FYV",
    "stationName": "Fayetteville, AR, United States"
  },
  {
    "stationCode": "GCM",
    "stationName": "George Town, Cayman Islands"
  },
  {
    "stationCode": "GDL",
    "stationName": "Guadalajara, Jalisco, Mexico"
  },
  {
    "stationCode": "GDT",
    "stationName": "Grand Turk, Turks and Caicos Islands"
  },
  {
    "stationCode": "GEG",
    "stationName": "Spokane, WA, United States"
  },
  {
    "stationCode": "GEO",
    "stationName": "Georgetown, Guyana"
  },
  {
    "stationCode": "GFK",
    "stationName": "Grand Forks, ND, United States"
  },
  {
    "stationCode": "GGG",
    "stationName": "Longview, TX, United States"
  },
  {
    "stationCode": "GGT",
    "stationName": "George Town, Bahamas"
  },
  {
    "stationCode": "GIG",
    "stationName": "Rio de Janeiro, Brazil"
  },
  {
    "stationCode": "GJT",
    "stationName": "Grand Junction, CO, United States"
  },
  {
    "stationCode": "GLA",
    "stationName": "Glasgow, Scotland, United Kingdom"
  },
  {
    "stationCode": "GMP",
    "stationName": "Seoul (Gimpo), South Korea"
  },
  {
    "stationCode": "GND",
    "stationName": "St. George's, Grenada"
  },
  {
    "stationCode": "GNV",
    "stationName": "Gainesville, FL, United States"
  },
  {
    "stationCode": "GOA",
    "stationName": "Genoa, Liguria, Italy"
  },
  {
    "stationCode": "GON",
    "stationName": "Groton/New London, CT, United States"
  },
  {
    "stationCode": "GPT",
    "stationName": "Gulfport/Biloxi, MS, United States"
  },
  {
    "stationCode": "GRB",
    "stationName": "Green Bay, WI, United States"
  },
  {
    "stationCode": "GRK",
    "stationName": "Fort Cavazos/Killeen, TX, United States"
  },
  {
    "stationCode": "GRR",
    "stationName": "Grand Rapids, MI, United States"
  },
  {
    "stationCode": "GRU",
    "stationName": "São Paulo, Brazil"
  },
  {
    "stationCode": "GSB",
    "stationName": "Goldsboro, NC, United States"
  },
  {
    "stationCode": "GSO",
    "stationName": "Greensboro, NC, United States"
  },
  {
    "stationCode": "GSP",
    "stationName": "Greenville/Spartanburg, SC, United States"
  },
  {
    "stationCode": "GTB",
    "stationName": "Fort Drum, NY, United States"
  },
  {
    "stationCode": "GTF",
    "stationName": "Great Falls, MT, United States"
  },
  {
    "stationCode": "GTR",
    "stationName": "Columbus/West Point/Starkville, MI, United States"
  },
  {
    "stationCode": "GUA",
    "stationName": "Guatemala City, Guatemala"
  },
  {
    "stationCode": "GUC",
    "stationName": "Gunnison, CO, United States"
  },
  {
    "stationCode": "GUS",
    "stationName": "Peru, IN, United States"
  },
  {
    "stationCode": "GWO",
    "stationName": "Greenwood, MI, United States"
  },
  {
    "stationCode": "GYE",
    "stationName": "Guayaquil, Ecuador"
  },
  {
    "stationCode": "GYN",
    "stationName": "Goiânia, Goiás, Brazil"
  },
  {
    "stationCode": "GYR",
    "stationName": "Goodyear, AZ, United States"
  },
  {
    "stationCode": "HAV",
    "stationName": "Havana, Cuba"
  },
  {
    "stationCode": "HDN",
    "stationName": "Hayden/Steamboat Springs, CO, United States"
  },
  {
    "stationCode": "HDQ",
    "stationName": "Headquarters DFW, TX, United States"
  },
  {
    "stationCode": "HEL",
    "stationName": "Helsinki, Finland"
  },
  {
    "stationCode": "HHN",
    "stationName": "Hahn, Germany"
  },
  {
    "stationCode": "HIF",
    "stationName": "Ogden, UT, United States"
  },
  {
    "stationCode": "HKG",
    "stationName": "Hong Kong, China"
  },
  {
    "stationCode": "HKY",
    "stationName": "Hickory, NC, United States"
  },
  {
    "stationCode": "HLN",
    "stationName": "Helena, MT, United States"
  },
  {
    "stationCode": "HMN",
    "stationName": "Alamogordo, NM, United States"
  },
  {
    "stationCode": "HMO",
    "stationName": "Hermosillo, Sonora, Mexico"
  },
  {
    "stationCode": "HND",
    "stationName": "Tokyo, Japan"
  },
  {
    "stationCode": "HNL",
    "stationName": "Honolulu, HI, United States"
  },
  {
    "stationCode": "HOG",
    "stationName": "Holguín, Cuba"
  },
  {
    "stationCode": "HOP",
    "stationName": "Hopkinsville, KY, United States"
  },
  {
    "stationCode": "HOU",
    "stationName": "Houston, TX, United States"
  },
  {
    "stationCode": "HPN",
    "stationName": "White Plains, NY, United States"
  },
  {
    "stationCode": "HRL",
    "stationName": "Harlingen, TX, United States"
  },
  {
    "stationCode": "HRT",
    "stationName": "Hurlburt Field, FL, United States"
  },
  {
    "stationCode": "HST",
    "stationName": "Homestead, FL, United States"
  },
  {
    "stationCode": "HSV",
    "stationName": "Huntsville, AL, United States"
  },
  {
    "stationCode": "HTS",
    "stationName": "Huntington, WV, United States"
  },
  {
    "stationCode": "HUF",
    "stationName": "Terre Haute, IN, United States"
  },
  {
    "stationCode": "HUX",
    "stationName": "Huatulco, Oaxaca, Mexico"
  },
  {
    "stationCode": "IAB",
    "stationName": "Wichita, KS, United States"
  },
  {
    "stationCode": "IAD",
    "stationName": "Washington, D.C., United States"
  },
  {
    "stationCode": "IAH",
    "stationName": "Houston, TX, United States"
  },
  {
    "stationCode": "ICN",
    "stationName": "Seoul, South Korea"
  },
  {
    "stationCode": "ICT",
    "stationName": "Wichita, KS, United States"
  },
  {
    "stationCode": "IDA",
    "stationName": "Idaho Falls, ID, United States"
  },
  {
    "stationCode": "IFP",
    "stationName": "Bullhead City, AZ, United States"
  },
  {
    "stationCode": "ILM",
    "stationName": "Wilmington, NC, United States"
  },
  {
    "stationCode": "ILN",
    "stationName": "Wilmington, OH, United States"
  },
  {
    "stationCode": "IND",
    "stationName": "Indianapolis, IN, United States"
  },
  {
    "stationCode": "INT",
    "stationName": "Winston-Salem, NC, United States"
  },
  {
    "stationCode": "ISO",
    "stationName": "Kinston, NC, United States"
  },
  {
    "stationCode": "ISP",
    "stationName": "Islip, NY, United States"
  },
  {
    "stationCode": "IST",
    "stationName": "Istanbul, Turkey"
  },
  {
    "stationCode": "IWA",
    "stationName": "Ivanovo, Russia"
  },
  {
    "stationCode": "JAC",
    "stationName": "Jackson, WY, United States"
  },
  {
    "stationCode": "JAI",
    "stationName": "Jaipur, Rajasthan, India"
  },
  {
    "stationCode": "JAN",
    "stationName": "Jackson, MI, United States"
  },
  {
    "stationCode": "JAX",
    "stationName": "Jacksonville, FL, United States"
  },
  {
    "stationCode": "JFK",
    "stationName": "New York City, NY, United States"
  },
  {
    "stationCode": "JLN",
    "stationName": "Joplin, MO, USA"
  },
  {
    "stationCode": "KEF",
    "stationName": "Reykjavik, Iceland"
  },
  {
    "stationCode": "KHH",
    "stationName": "Kaohsiung, Taiwan"
  },
  {
    "stationCode": "KIN",
    "stationName": "Kingston, Jamaica"
  },
  {
    "stationCode": "KIX",
    "stationName": "Osaka, Japan"
  },
  {
    "stationCode": "KOA",
    "stationName": "Kailua-Kona, HI, USA"
  },
  {
    "stationCode": "KWI",
    "stationName": "Kuwait City, Kuwait"
  },
  {
    "stationCode": "LAF",
    "stationName": "Lafayette, IN, USA"
  },
  {
    "stationCode": "LAL",
    "stationName": "Lakeland, FL, USA"
  },
  {
    "stationCode": "LAN",
    "stationName": "Lansing, MI, USA"
  },
  {
    "stationCode": "LAP",
    "stationName": "La Paz, Mexico"
  },
  {
    "stationCode": "LAR",
    "stationName": "Laramie, WY, USA"
  },
  {
    "stationCode": "LAS",
    "stationName": "Las Vegas, NV, USA"
  },
  {
    "stationCode": "LAW",
    "stationName": "Lawton, OK, USA"
  },
  {
    "stationCode": "LAX",
    "stationName": "Los Angeles, CA, USA"
  },
  {
    "stationCode": "LBB",
    "stationName": "Lubbock, TC, USA"
  },
  {
    "stationCode": "LBF",
    "stationName": "North Platte, NE, USA"
  },
  {
    "stationCode": "LCH",
    "stationName": "Lake Charles, LA, USA"
  },
  {
    "stationCode": "LCK",
    "stationName": "Columbus, OH, USA"
  },
  {
    "stationCode": "LEX",
    "stationName": "Lexington, KY, USA"
  },
  {
    "stationCode": "LFI",
    "stationName": "Lafayette, LA, USA"
  },
  {
    "stationCode": "LFT",
    "stationName": "Lafayette, LA, USA"
  },
  {
    "stationCode": "LGA",
    "stationName": "New York City, NY, USA"
  },
  {
    "stationCode": "LGB",
    "stationName": "Long Beach, CA, USA"
  },
  {
    "stationCode": "LGW",
    "stationName": "London, United Kingdom"
  },
  {
    "stationCode": "LHR",
    "stationName": "London, United Kingdom"
  },
  {
    "stationCode": "LIH",
    "stationName": "Lihue, HI, USA"
  },
  {
    "stationCode": "LIM",
    "stationName": "Lima, Peru"
  },
  {
    "stationCode": "LIR",
    "stationName": "Liberia, Costa Rica"
  },
  {
    "stationCode": "LIS",
    "stationName": "Lisbon, Portugal"
  },
  {
    "stationCode": "LIT",
    "stationName": "Little Rock, AR, USA"
  },
  {
    "stationCode": "LMM",
    "stationName": "Los Mochis, Mexico"
  },
  {
    "stationCode": "LNK",
    "stationName": "Lincoln, NE, USA"
  },
  {
    "stationCode": "LOT",
    "stationName": "Chicago, IL, USA"
  },
  {
    "stationCode": "LPB",
    "stationName": "La Paz, Bolivia"
  },
  {
    "stationCode": "LRD",
    "stationName": "Laredo, TX, USA"
  },
  {
    "stationCode": "LRM",
    "stationName": "La Romana, Dominican Republic"
  },
  {
    "stationCode": "LSE",
    "stationName": "La Crosse, WI, USA"
  },
  {
    "stationCode": "LSF",
    "stationName": "Lufkin, TX, USA"
  },
  {
    "stationCode": "LSV",
    "stationName": "Las Vegas, NV, USA"
  },
  {
    "stationCode": "LUX",
    "stationName": "Luxembourg City, Luxembourg"
  },
  {
    "stationCode": "LWB",
    "stationName": "Lewisburg, WV, USA"
  },
  {
    "stationCode": "LWS",
    "stationName": "Lewiston, ID, USA"
  },
  {
    "stationCode": "LYS",
    "stationName": "Lyon, France"
  },
  {
    "stationCode": "MAD",
    "stationName": "Madrid, Spain"
  },
  {
    "stationCode": "MAF",
    "stationName": "Midland, TX, USA"
  },
  {
    "stationCode": "MAN",
    "stationName": "Manchester, United Kingdom"
  },
  {
    "stationCode": "MAO",
    "stationName": "Manaus, Brazil"
  },
  {
    "stationCode": "MAR",
    "stationName": "Maracaibo, Venezuela"
  },
  {
    "stationCode": "MBJ",
    "stationName": "Montego Bay, Jamaica"
  },
  {
    "stationCode": "MCF",
    "stationName": "McConnell AFB, KS, USA"
  },
  {
    "stationCode": "MCI",
    "stationName": "Kansas City, MO, USA"
  },
  {
    "stationCode": "MCO",
    "stationName": "Orlando, FL, USA"
  },
  {
    "stationCode": "MCT",
    "stationName": "Muscat, Oman"
  },
  {
    "stationCode": "MDE",
    "stationName": "Medellin, Colombia"
  },
  {
    "stationCode": "MDH",
    "stationName": "Carbondale, IL, USA"
  },
  {
    "stationCode": "MDT",
    "stationName": "Harrisburg, PA, USA"
  },
  {
    "stationCode": "MDW",
    "stationName": "Chicago, IL, USA"
  },
  {
    "stationCode": "MDZ",
    "stationName": "Mendoza, Argentina"
  },
  {
    "stationCode": "MEC",
    "stationName": "Manta, Ecuador"
  },
  {
    "stationCode": "MEM",
    "stationName": "Memphis, TN, USA"
  },
  {
    "stationCode": "MER",
    "stationName": "Merced, CA, USA"
  },
  {
    "stationCode": "MEX",
    "stationName": "Mexico City, Mexico"
  },
  {
    "stationCode": "MFE",
    "stationName": "McAllen, TX, USA"
  },
  {
    "stationCode": "MFM",
    "stationName": "Macau, China"
  },
  {
    "stationCode": "MFR",
    "stationName": "Medford, Oregon, USA"
  },
  {
    "stationCode": "MGA",
    "stationName": "Managua, Nicaragua"
  },
  {
    "stationCode": "MGM",
    "stationName": "Montgomery, AL, USA"
  },
  {
    "stationCode": "MHK",
    "stationName": "Manhattan, KS, USA"
  },
  {
    "stationCode": "MHT",
    "stationName": "Manchester, NH, USA"
  },
  {
    "stationCode": "MHV",
    "stationName": "Mojave, CA, USA"
  },
  {
    "stationCode": "MIA",
    "stationName": "Miami, FL, USA"
  },
  {
    "stationCode": "MIB",
    "stationName": "Mildura, Victoria, Australia"
  },
  {
    "stationCode": "MID",
    "stationName": "Merida, Yucatan, Mexico"
  },
  {
    "stationCode": "MKC",
    "stationName": "Kansas City, MO, USA"
  },
  {
    "stationCode": "MKE",
    "stationName": "Milwaukee, WI, USA"
  },
  {
    "stationCode": "MLB",
    "stationName": "Melbourne, FL, USA"
  },
  {
    "stationCode": "MLI",
    "stationName": "Moline, IL, USA"
  },
  {
    "stationCode": "MLM",
    "stationName": "Morelia, Michoacán, Mexico"
  },
  {
    "stationCode": "MLU",
    "stationName": "Monroe, LA, USA"
  },
  {
    "stationCode": "MOB",
    "stationName": "Mobile, AL, USA"
  },
  {
    "stationCode": "MRY",
    "stationName": "Monterey, CA, USA"
  },
  {
    "stationCode": "MSH",
    "stationName": "Mossel Bay, Western Cape, South Africa"
  },
  {
    "stationCode": "MSN",
    "stationName": "Madison, WI, USA"
  },
  {
    "stationCode": "MSO",
    "stationName": "Missoula, MT, USA"
  },
  {
    "stationCode": "MSP",
    "stationName": "Minneapolis, MN, USA"
  },
  {
    "stationCode": "MSY",
    "stationName": "New Orleans, LA, USA"
  },
  {
    "stationCode": "MTC",
    "stationName": "Martha's Vineyard, MA, USA"
  },
  {
    "stationCode": "MTJ",
    "stationName": "Montrose, CO, USA"
  },
  {
    "stationCode": "MTY",
    "stationName": "Monterrey, Nuevo León, Mexico"
  },
  {
    "stationCode": "MUC",
    "stationName": "Munich, Bavaria, Germany"
  },
  {
    "stationCode": "MVD",
    "stationName": "Montevideo, Uruguay"
  },
  {
    "stationCode": "MWA",
    "stationName": "Marion, IL, USA"
  },
  {
    "stationCode": "MWH",
    "stationName": "Moses Lake, WA, USA"
  },
  {
    "stationCode": "MXE",
    "stationName": "Moline, IL, USA"
  },
  {
    "stationCode": "MXF",
    "stationName": "Montgomery, AL, USA"
  },
  {
    "stationCode": "MXP",
    "stationName": "Milan, Lombardy, Italy"
  },
  {
    "stationCode": "MYR",
    "stationName": "Myrtle Beach, SC, USA"
  },
  {
    "stationCode": "MZJ",
    "stationName": "Mesa, AZ, USA"
  },
  {
    "stationCode": "MZT",
    "stationName": "Mazatlán, Sinaloa, Mexico"
  },
  {
    "stationCode": "NAP",
    "stationName": "Naples, Campania, Italy"
  },
  {
    "stationCode": "NAS",
    "stationName": "Nassau, Bahamas"
  },
  {
    "stationCode": "NBC",
    "stationName": "Nabire, Papua, Indonesia"
  },
  {
    "stationCode": "NBW",
    "stationName": "Newport News, VA, USA"
  },
  {
    "stationCode": "NCE",
    "stationName": "Nice, Provence-Alpes-Côte d'Azur, France"
  },
  {
    "stationCode": "NFW",
    "stationName": "Norfolk, VA, USA"
  },
  {
    "stationCode": "NGO",
    "stationName": "Nagoya, Aichi, Japan"
  },
  {
    "stationCode": "NGP",
    "stationName": "Corpus Christi, TX, USA"
  },
  {
    "stationCode": "NGU",
    "stationName": "Norfolk, VA, USA"
  },
  {
    "stationCode": "NHZ",
    "stationName": "Nizhnevartovsk, Russia"
  },
  {
    "stationCode": "NIP",
    "stationName": "Nipawin, Saskatchewan, Canada"
  },
  {
    "stationCode": "NJK",
    "stationName": "Nizhnekamsk, Russia"
  },
  {
    "stationCode": "NKT",
    "stationName": "Nakhon Ratchasima, Thailand"
  },
  {
    "stationCode": "NKW",
    "stationName": "Nakhon Si Thammarat, Thailand"
  },
  {
    "stationCode": "NKX",
    "stationName": "San Diego, CA, USA"
  },
  {
    "stationCode": "NQX",
    "stationName": "Key West, FL, USA"
  },
  {
    "stationCode": "NRR",
    "stationName": "Norrköping, Sweden"
  },
  {
    "stationCode": "NRT",
    "stationName": "Narita, Chiba, Japan"
  },
  {
    "stationCode": "NSY",
    "stationName": "Nassau, Bahamas"
  },
  {
    "stationCode": "NTD",
    "stationName": "North Island, CA, USA"
  },
  {
    "stationCode": "NUE",
    "stationName": "Nuremberg, Bavaria, Germany"
  },
  {
    "stationCode": "NXX",
    "stationName": "Newport News, VA, USA"
  },
  {
    "stationCode": "NYL",
    "stationName": "New York, NY, USA"
  },
  {
    "stationCode": "NZY",
    "stationName": "San Diego, CA, USA"
  },
  {
    "stationCode": "OAJ",
    "stationName": "Jacksonville, NC, USA"
  },
  {
    "stationCode": "OAK",
    "stationName": "Oakland, CA, USA"
  },
  {
    "stationCode": "OAX",
    "stationName": "Oaxaca, Oaxaca, Mexico"
  },
  {
    "stationCode": "OCF",
    "stationName": "Ocala, FL, USA"
  },
  {
    "stationCode": "OGG",
    "stationName": "Kahului, HI, USA"
  },
  {
    "stationCode": "OKC",
    "stationName": "Oklahoma City, OK, USA"
  },
  {
    "stationCode": "OKO",
    "stationName": "Oklahoma City, OK, USA"
  },
  {
    "stationCode": "OMA",
    "stationName": "Omaha, NE, USA"
  },
  {
    "stationCode": "ONT",
    "stationName": "Ontario, CA, USA"
  },
  {
    "stationCode": "OPF",
    "stationName": "Miami, FL, USA"
  },
  {
    "stationCode": "OPO",
    "stationName": "Porto, Portugal"
  },
  {
    "stationCode": "ORD",
    "stationName": "Chicago, IL, USA"
  },
  {
    "stationCode": "ORF",
    "stationName": "Norfolk, VA, USA"
  },
  {
    "stationCode": "ORY",
    "stationName": "Paris, France"
  },
  {
    "stationCode": "OSC",
    "stationName": "Oscoda, MI, USA"
  },
  {
    "stationCode": "OSH",
    "stationName": "Oshkosh, WI, USA"
  },
  {
    "stationCode": "PAE",
    "stationName": "Everett, WA, USA"
  },
  {
    "stationCode": "PAP",
    "stationName": "Port-au-Prince, Haiti"
  },
  {
    "stationCode": "PBC",
    "stationName": "Punta Cana, Dominican Republic"
  },
  {
    "stationCode": "PBI",
    "stationName": "West Palm Beach, FL, USA"
  },
  {
    "stationCode": "PBM",
    "stationName": "Paramaribo, Suriname"
  },
  {
    "stationCode": "PDL",
    "stationName": "Ponta Delgada, Portugal"
  },
  {
    "stationCode": "PDX",
    "stationName": "Portland, OR, USA"
  },
  {
    "stationCode": "PEI",
    "stationName": "Pereira, Colombia"
  },
  {
    "stationCode": "PEK",
    "stationName": "Beijing, China"
  },
  {
    "stationCode": "PGD",
    "stationName": "Punta Gorda, FL, USA"
  },
  {
    "stationCode": "PGV",
    "stationName": "Greenville, NC, USA"
  },
  {
    "stationCode": "PHF",
    "stationName": "Newport News, VA, USA"
  },
  {
    "stationCode": "PHL",
    "stationName": "Philadelphia, PA, USA"
  },
  {
    "stationCode": "PHX",
    "stationName": "Phoenix, AZ, USA"
  },
  {
    "stationCode": "PIA",
    "stationName": "Peoria, IL, USA"
  },
  {
    "stationCode": "PIB",
    "stationName": "Pine Bluff, AR, USA"
  },
  {
    "stationCode": "PIE",
    "stationName": "St. Petersburg, FL, USA"
  },
  {
    "stationCode": "PIH",
    "stationName": "Pocatello, ID, USA"
  },
  {
    "stationCode": "PIK",
    "stationName": "Glasgow, Scotland, UK"
  },
  {
    "stationCode": "PIO",
    "stationName": "Pisco, Peru"
  },
  {
    "stationCode": "PIT",
    "stationName": "Pittsburgh, PA, USA"
  },
  {
    "stationCode": "PKC",
    "stationName": "Kodiak, AK, USA"
  },
  {
    "stationCode": "PLS",
    "stationName": "Providenciales, Turks and Caicos Islands"
  },
  {
    "stationCode": "PNS",
    "stationName": "Pensacola, FL, USA"
  },
  {
    "stationCode": "POA",
    "stationName": "Porto Alegre, Brazil"
  },
  {
    "stationCode": "POB",
    "stationName": "Palo Alto, CA, USA"
  },
  {
    "stationCode": "POP",
    "stationName": "Puerto Plata, Dominican Republic"
  },
  {
    "stationCode": "POS",
    "stationName": "Port of Spain, Trinidad and Tobago"
  },
  {
    "stationCode": "POZ",
    "stationName": "Poznań, Poland"
  },
  {
    "stationCode": "PPT",
    "stationName": "Papeete, French Polynesia"
  },
  {
    "stationCode": "PRG",
    "stationName": "Prague, Czech Republic"
  },
  {
    "stationCode": "PSM",
    "stationName": "Portsmouth, NH, USA"
  },
  {
    "stationCode": "PSP",
    "stationName": "Palm Springs, CA, USA"
  },
  {
    "stationCode": "PTK",
    "stationName": "Pontiac, MI, USA"
  },
  {
    "stationCode": "PTP",
    "stationName": "Pointe-à-Pitre, Guadeloupe"
  },
  {
    "stationCode": "PTY",
    "stationName": "Panama City, Panama"
  },
  {
    "stationCode": "PUB",
    "stationName": "Pueblo, CO, USA"
  },
  {
    "stationCode": "PUJ",
    "stationName": "Punta Cana, Dominican Republic"
  },
  {
    "stationCode": "PVD",
    "stationName": "Providence, RI, USA"
  },
  {
    "stationCode": "PVG",
    "stationName": "Shanghai, China"
  },
  {
    "stationCode": "PVR",
    "stationName": "Puerto Vallarta, Mexico"
  },
  {
    "stationCode": "PVU",
    "stationName": "Provo, UT, USA"
  },
  {
    "stationCode": "PWM",
    "stationName": "Portland, ME, USA"
  },
  {
    "stationCode": "QRO",
    "stationName": "Querétaro, Mexico"
  },
  {
    "stationCode": "RAP",
    "stationName": "Rapid City, SD, USA"
  },
  {
    "stationCode": "RBR",
    "stationName": "Rio Branco, Brazil"
  },
  {
    "stationCode": "RCA",
    "stationName": "Rochester, MN, USA"
  },
  {
    "stationCode": "RDM",
    "stationName": "Redmond, OR, USA"
  },
  {
    "stationCode": "RDU",
    "stationName": "Raleigh-Durham, NC, USA"
  },
  {
    "stationCode": "REC",
    "stationName": "Recife, Brazil"
  },
  {
    "stationCode": "RES",
    "stationName": "Resistencia, Argentina"
  },
  {
    "stationCode": "RFD",
    "stationName": "Rockford, IL, USA"
  },
  {
    "stationCode": "RIC",
    "stationName": "Richmond, VA, USA"
  },
  {
    "stationCode": "RIV",
    "stationName": "Riverside, CA, USA"
  },
  {
    "stationCode": "RKS",
    "stationName": "Rock Springs, WY, USA"
  },
  {
    "stationCode": "RMS",
    "stationName": "Ramsar, Iran"
  },
  {
    "stationCode": "RNO",
    "stationName": "Reno, NV, USA"
  },
  {
    "stationCode": "ROA",
    "stationName": "Roanoke, VA, USA"
  },
  {
    "stationCode": "ROC",
    "stationName": "Rochester, NY, USA"
  },
  {
    "stationCode": "ROS",
    "stationName": "Rosario, Argentina"
  },
  {
    "stationCode": "ROW",
    "stationName": "Roswell, New Mexico, USA"
  },
  {
    "stationCode": "RST",
    "stationName": "Rochester, MN, USA"
  },
  {
    "stationCode": "RSW",
    "stationName": "Fort Myers, FL, USA"
  },
  {
    "stationCode": "RTB",
    "stationName": "Roatan, Honduras"
  },
  {
    "stationCode": "RVR",
    "stationName": "Riverside, CA, USA"
  },
  {
    "stationCode": "RVS",
    "stationName": "Rivas, Rivas, Nicaragua"
  },
  {
    "stationCode": "SAL",
    "stationName": "San Salvador, La Libertad, El Salvador"
  },
  {
    "stationCode": "SAN",
    "stationName": "San Diego, CA, USA"
  },
  {
    "stationCode": "SAP",
    "stationName": "San Pedro Sula, Cortés, Honduras"
  },
  {
    "stationCode": "SAT",
    "stationName": "San Antonio, TX, USA"
  },
  {
    "stationCode": "SAV",
    "stationName": "Savannah, GA, USA"
  },
  {
    "stationCode": "SBA",
    "stationName": "Santa Barbara, CA, USA"
  },
  {
    "stationCode": "SBD",
    "stationName": "San Bernardino, CA, USA"
  },
  {
    "stationCode": "SBN",
    "stationName": "South Bend, IN, USA"
  },
  {
    "stationCode": "SBP",
    "stationName": "San Luis Obispo, CA, USA"
  },
  {
    "stationCode": "SCL",
    "stationName": "Santiago, Santiago Metropolitan, Chile"
  },
  {
    "stationCode": "SCQ",
    "stationName": "Santiago de Compostela, Galicia, Spain"
  },
  {
    "stationCode": "SCU",
    "stationName": "Santiago de Cuba, Santiago de Cuba, Cuba"
  },
  {
    "stationCode": "SDF",
    "stationName": "Louisville, KY, USA"
  },
  {
    "stationCode": "SDQ",
    "stationName": "Santo Domingo, Distrito Nacional, Dominican Republic"
  },
  {
    "stationCode": "SEA",
    "stationName": "Seattle, WA, USA"
  },
  {
    "stationCode": "SFB",
    "stationName": "Sanford, FL, USA"
  },
  {
    "stationCode": "SFO",
    "stationName": "San Francisco, CA, USA"
  },
  {
    "stationCode": "SGF",
    "stationName": "Springfield, MO, USA"
  },
  {
    "stationCode": "SHA",
    "stationName": "Shanghai, Shanghai, China"
  },
  {
    "stationCode": "SHV",
    "stationName": "Shreveport, LA, USA"
  },
  {
    "stationCode": "SJC",
    "stationName": "San Jose, CA, USA"
  },
  {
    "stationCode": "SJD",
    "stationName": "San José del Cabo, Baja California Sur, Mexico"
  },
  {
    "stationCode": "SJO",
    "stationName": "San José, San José, Costa Rica"
  },
  {
    "stationCode": "SJT",
    "stationName": "San Angelo, TX, USA"
  },
  {
    "stationCode": "SJU",
    "stationName": "San Juan, Puerto Rico, USA"
  },
  {
    "stationCode": "SJW",
    "stationName": "San José, Guayas, Ecuador"
  },
  {
    "stationCode": "SKB",
    "stationName": "Basseterre, Saint George, Saint Kitts and Nevis"
  },
  {
    "stationCode": "SKF",
    "stationName": "San Francisco, CA, USA"
  },
  {
    "stationCode": "SKP",
    "stationName": "Skopje, Skopje, North Macedonia"
  },
  {
    "stationCode": "SLC",
    "stationName": "Salt Lake City, UT, USA"
  },
  {
    "stationCode": "SLP",
    "stationName": "San Luis Potosí, San Luis Potosí, Mexico"
  },
  {
    "stationCode": "SMA",
    "stationName": "Santa Maria, CA, USA"
  },
  {
    "stationCode": "SMF",
    "stationName": "Sacramento, CA, USA"
  },
  {
    "stationCode": "SNA",
    "stationName": "Santa Ana, CA, USA"
  },
  {
    "stationCode": "SNN",
    "stationName": "Shannon, County Clare, Ireland"
  },
  {
    "stationCode": "SNU",
    "stationName": "Santa Clara, Villa Clara, Cuba"
  },
  {
    "stationCode": "SOF",
    "stationName": "Sofia, Sofia City, Bulgaria"
  },
  {
    "stationCode": "SPI",
    "stationName": "Springfield, IL, USA"
  },
  {
    "stationCode": "SPS",
    "stationName": "Wichita Falls, TX, USA"
  },
  {
    "stationCode": "SRQ",
    "stationName": "Sarasota, FL, USA"
  },
  {
    "stationCode": "SSA",
    "stationName": "Salvador, Bahia, Brazil"
  },
  {
    "stationCode": "SSC",
    "stationName": "Shreveport, LA, USA"
  },
  {
    "stationCode": "STI",
    "stationName": "Santiago, Santiago, Dominican Republic"
  },
  {
    "stationCode": "STJ",
    "stationName": "Saint Joseph, MO, USA"
  },
  {
    "stationCode": "STL",
    "stationName": "St. Louis, MO, USA"
  },
  {
    "stationCode": "STM",
    "stationName": "Santarem, Pará, Brazil"
  },
  {
    "stationCode": "STN",
    "stationName": "Stansted, England, United Kingdom"
  },
  {
    "stationCode": "STS",
    "stationName": "Santa Rosa, CA, USA"
  },
  {
    "stationCode": "STT",
    "stationName": "Saint Thomas, Virgin Islands, USA"
  },
  {
    "stationCode": "STX",
    "stationName": "Saint Croix, Virgin Islands, USA"
  },
  {
    "stationCode": "SUX",
    "stationName": "Sioux City, IA, USA"
  },
  {
    "stationCode": "SVD",
    "stationName": "Kingstown, Saint George, Saint Vincent and the Grenadines"
  },
  {
    "stationCode": "SVN",
    "stationName": "Savaneta, Aruba, Aruba"
  },
  {
    "stationCode": "SWF",
    "stationName": "New Windsor, NY, USA"
  },
  {
    "stationCode": "SWO",
    "stationName": "Stillwater, OK, USA"
  },
  {
    "stationCode": "SXM",
    "stationName": "Simpson Bay, Sint Maarten, Sint Maarten"
  },
  {
    "stationCode": "SYA",
    "stationName": "Seya, Hokkaido, Japan"
  },
  {
    "stationCode": "SYD",
    "stationName": "Sydney, New South Wales, Australia"
  },
  {
    "stationCode": "SYR",
    "stationName": "Syracuse, NY, USA"
  },
  {
    "stationCode": "SYY",
    "stationName": "Seymour, Queensland, Australia"
  },
  {
    "stationCode": "SZL",
    "stationName": "Szeged, Csongrád-Csanád, Hungary"
  },
  {
    "stationCode": "TCL",
    "stationName": "Tuscaloosa, AL, USA"
  },
  {
    "stationCode": "TCM",
    "stationName": "Tacoma, WA, USA"
  },
  {
    "stationCode": "TER",
    "stationName": "Terceira, Azores, Portugal"
  },
  {
    "stationCode": "TGU",
    "stationName": "Tegucigalpa, Francisco Morazán, Honduras"
  },
  {
    "stationCode": "TIK",
    "stationName": "Tikhoretsk, Krasnodar Krai, Russia"
  },
  {
    "stationCode": "TLH",
    "stationName": "Tallahassee, FL, USA"
  },
  {
    "stationCode": "TLV",
    "stationName": "Tel Aviv, Tel Aviv, Israel"
  },
  {
    "stationCode": "TOL",
    "stationName": "Toledo, OH, USA"
  },
  {
    "stationCode": "TPA",
    "stationName": "Tampa, FL, USA"
  },
  {
    "stationCode": "TPE",
    "stationName": "Taipei, Taipei City, Taiwan"
  },
  {
    "stationCode": "TQO",
    "stationName": "Tocumen, Panama City, Panama"
  },
  {
    "stationCode": "TSN",
    "stationName": "Tianjin, Tianjin, China"
  },
  {
    "stationCode": "TUL",
    "stationName": "Tulsa, OK, USA"
  },
  {
    "stationCode": "TUP",
    "stationName": "Tupelo, MS, USA"
  },
  {
    "stationCode": "TUS",
    "stationName": "Tucson, AZ, USA"
  },
  {
    "stationCode": "TVC",
    "stationName": "Traverse City, MI, USA"
  },
  {
    "stationCode": "TVF",
    "stationName": "Thief River Falls, MN, USA"
  },
  {
    "stationCode": "TXK",
    "stationName": "Texarkana, AR, USA"
  },
  {
    "stationCode": "TXL",
    "stationName": "Berlin, Berlin, Germany"
  },
  {
    "stationCode": "TYS",
    "stationName": "Knoxville, TN, USA"
  },
  {
    "stationCode": "TZL",
    "stationName": "Tuzla, Federation of Bosnia and Herzegovina, Bosnia and Herzegovina"
  },
  {
    "stationCode": "TZR",
    "stationName": "Tura, Russia"
  },
  {
    "stationCode": "UAB",
    "stationName": "Udabno, Georgia"
  },
  {
    "stationCode": "UIO",
    "stationName": "Quito, Pichincha, Ecuador"
  },
  {
    "stationCode": "UNV",
    "stationName": "University Park, Pennsylvania, USA"
  },
  {
    "stationCode": "UVF",
    "stationName": "Vieux Fort, Saint Lucia, Saint Lucia"
  },
  {
    "stationCode": "VCE",
    "stationName": "Venice, Veneto, Italy"
  },
  {
    "stationCode": "VCP",
    "stationName": "Campinas, São Paulo, Brazil"
  },
  {
    "stationCode": "VCV",
    "stationName": "Victorville, CA, USA"
  },
  {
    "stationCode": "VER",
    "stationName": "Veracruz, Veracruz, Mexico"
  },
  {
    "stationCode": "VLC",
    "stationName": "Valencia, Valencia, Spain"
  },
  {
    "stationCode": "VLN",
    "stationName": "Valencia, Carabobo, Venezuela"
  },
  {
    "stationCode": "VOK",
    "stationName": "Vorkuta, Komi, Russia"
  },
  {
    "stationCode": "VPS",
    "stationName": "Fort Walton Beach, FL, USA"
  },
  {
    "stationCode": "VQQ",
    "stationName": "Victoria, TX, USA"
  },
  {
    "stationCode": "VRA",
    "stationName": "Varadero, Matanzas, Cuba"
  },
  {
    "stationCode": "VVI",
    "stationName": "Santa Cruz, Santa Cruz, Bolivia"
  },
  {
    "stationCode": "WRB",
    "stationName": "Wrightstown, NJ, USA"
  },
  {
    "stationCode": "WRI",
    "stationName": "McGuire AFB, NJ, USA"
  },
  {
    "stationCode": "XFW",
    "stationName": "Hamburg, Hamburg, Germany"
  },
  {
    "stationCode": "XHA",
    "stationName": "Hannover, Lower Saxony, Germany"
  },
  {
    "stationCode": "XJD",
    "stationName": "Jingdezhen, Jiangxi, China"
  },
  {
    "stationCode": "XNA",
    "stationName": "Bentonville, AR, USA"
  },
  {
    "stationCode": "XPL",
    "stationName": "Plovdiv, Plovdiv, Bulgaria"
  },
  {
    "stationCode": "YEG",
    "stationName": "Edmonton, Alberta, Canada"
  },
  {
    "stationCode": "YFB",
    "stationName": "Iqaluit, Nunavut, Canada"
  },
  {
    "stationCode": "YHM",
    "stationName": "Hamilton, Ontario, Canada"
  },
  {
    "stationCode": "YHU",
    "stationName": "Montreal, Quebec, Canada"
  },
  {
    "stationCode": "YHZ",
    "stationName": "Halifax, Nova Scotia, Canada"
  },
  {
    "stationCode": "YIP",
    "stationName": "Detroit, MI, USA"
  },
  {
    "stationCode": "YJT",
    "stationName": "Stephenville, Newfoundland and Labrador, Canada"
  },
  {
    "stationCode": "YKM",
    "stationName": "Yakima, WA, USA"
  },
  {
    "stationCode": "YLW",
    "stationName": "Kelowna, British Columbia, Canada"
  },
  {
    "stationCode": "YMX",
    "stationName": "Montreal, Quebec, Canada"
  },
  {
    "stationCode": "YOW",
    "stationName": "Ottawa, Ontario, Canada"
  },
  {
    "stationCode": "YQB",
    "stationName": "Quebec City, Quebec, Canada"
  },
  {
    "stationCode": "YQM",
    "stationName": "Moncton, New Brunswick, Canada"
  },
  {
    "stationCode": "YQX",
    "stationName": "Gander, Newfoundland and Labrador, Canada"
  },
  {
    "stationCode": "YUL",
    "stationName": "Montreal, Quebec, Canada"
  },
  {
    "stationCode": "YUM",
    "stationName": "Yuma, AZ, USA"
  },
  {
    "stationCode": "YVR",
    "stationName": "Vancouver, British Columbia, Canada"
  },
  {
    "stationCode": "YWG",
    "stationName": "Winnipeg, Manitoba, Canada"
  },
  {
    "stationCode": "YYC",
    "stationName": "Calgary, Alberta, Canada"
  },
  {
    "stationCode": "YYR",
    "stationName": "Happy Valley-Goose Bay, Newfoundland and Labrador, Canada"
  },
  {
    "stationCode": "YYT",
    "stationName": "St. John's, Newfoundland and Labrador, Canada"
  },
  {
    "stationCode": "YYZ",
    "stationName": "Toronto, Ontario, Canada"
  },
  {
    "stationCode": "YZF",
    "stationName": "Yellowknife, Northwest Territories, Canada"
  },
  {
    "stationCode": "ZIH",
    "stationName": "Ixtapa, Guerrero, Mexico"
  },
  {
    "stationCode": "ZLO",
    "stationName": "Manzanillo, Colima, Mexico"
  },
  {
    "stationCode": "ZRH",
    "stationName": "Zurich, Zurich, Switzerland"
  },
  {
    "stationCode": "ZSA",
    "stationName": "San Andros, Bahamas"
  }
];